module.exports = __webpack_public_path__ + "static/wedding-3-972ca811bfac6c8bec808860e16c3913.png";